/**
 * Single source of truth for the site's FAQ copy. Used by the /questions
 * page, the homepage's short FAQ block, and the FAQPage JSON-LD schema, so
 * every surface agrees and there is only one place to update an answer.
 */
export const FAQ = [
  {
    q: "What do you actually build?",
    a: "Custom software for the work your company depends on: ERP and CRM systems, internal tools, customer portals, automations, AI agents and Company Brains. Sometimes the answer is one small workflow. Sometimes it grows into the system a whole team runs on.",
  },
  {
    q: "Do we need to know what kind of software we want?",
    a: "No. Tell us what is slow, repeated, confusing or too dependent on one person. We will work out whether the sensible answer is better automation, a custom tool, an ERP or CRM module, an AI agent, or simply a process change.",
  },
  {
    q: "Can you build our own ERP or CRM?",
    a: "Yes. We can build a complete system or replace one painful part in stages. It follows your fields, approvals, reporting and way of working, and you own the custom code instead of paying AUT labs forever for each new user.",
  },
  {
    q: "Will the automation disappear if we build something larger?",
    a: "No. Automation is often the best first step. A useful workflow can stay exactly as it is, connect to your current software, or later become part of a custom ERP, CRM or Company Brain. We build so the first win is not thrown away.",
  },
  {
    q: "Will AI make decisions on its own?",
    a: "Not where the decision needs a person. The system can prepare the work, check rules, draft a reply and suggest the next step. Your team approves anything important, and the system records what happened.",
  },
  {
    q: "Can it use our company knowledge?",
    a: "Yes. A Company Brain can help people and software find the right policy, customer history, document or past decision, while respecting who is allowed to see what. For a narrow specialist job, we can also adapt private AI models when the data genuinely supports it.",
  },
  {
    q: "Do we have to replace our current software?",
    a: "Usually not. We can connect the tools that still work, build over the gaps or replace one weak part at a time. Nothing touches a live system until the permissions, testing and approval steps are agreed with you.",
  },
  {
    q: "Which businesses do you work with?",
    a: "We work with SMEs and MSMEs, established and family-run businesses, professional firms, fintech, financial services, manufacturing, distribution, logistics and technology teams. Our speciality is messy, repeated work spread across people, documents and disconnected software.",
  },
  {
    q: "Who owns the code and our data?",
    a: "You own the custom code and your data. We do not resell your data or train unrelated systems on it. If we stop working together, the software remains with you and can keep running.",
  },
  {
    q: "What does it cost, and how do we start?",
    a: "We start with a free 15-minute call. A focused build is priced against a clear scope; larger ERP or CRM work is split into phases. You see the project cost, expected running costs and optional support before you commit.",
  },
];
